
import { Options, Vue } from 'vue-class-component';
import { ModalServices } from '@/services/ModalServices';
import { LoginServices } from './services/LoginServices';
import { CompanyClient, LocalizedEntityClient } from './services/Services';
import store from './store';
import * as OM from '@/Model'
import { StorageServices } from './services/StorageServices';
import { CommonServices } from './services/CommonServices';
import LanguageSelector from '@/components/languageSelector.vue';

@Options({
    components: {
        LanguageSelector
    }
})
export default class App extends Vue {

    loading: boolean = true;

    mounted(){
        if (store.state.maintenance) {
            this.loading = false;
            this.$router.push('/maintenance');
            return;
        }


        Promise.all([
            CompanyClient.getByCompanyCode(store.state.appCode),
            LocalizedEntityClient.getEnabledLanguages()
        ])
        .then(([company, enabledLanguages]) => {
            store.state.company = company;
            store.state.consts.enabledLanguages = enabledLanguages;

            const companyLanguages = store.state.company?.enabledLanguages || [];
            const defaultLang = companyLanguages.length > 0 ? companyLanguages[0] : 'it-IT';

            store.state.user = StorageServices.getLoggedUser()
            if (!store.state.user || !store.state.user.preferredCulture) {
                store.state.user = new OM.LoggedUserVM()
                store.state.user.preferredCulture = defaultLang
            }

            if (!companyLanguages.includes(store.state.user.preferredCulture)) {
                store.state.user.preferredCulture = defaultLang
                StorageServices.setLoggedUser(store.state.user)
            }

            CommonServices.setLanguage(store.state.user.preferredCulture);

            return LocalizedEntityClient.getAllApp(store.state.appCode);
        })
        .then(localizedValues => {
            store.state.consts.localizedValues = localizedValues;

            window.document.title = store.state.company.name;

            this.loading = false;
            if(this.$route.name == 'change_password' || this.$route.name == 'confirm_email'){
                return;
            }

            this.checkAutologin()
        })

        ModalServices.setOpModal(this.$opModal);
    }

    checkAutologin() {
      const loggedUser = store.state.user
    
      if (
        loggedUser &&
        loggedUser.token &&
        loggedUser.refreshToken &&
        loggedUser.refreshTokenExpiryTime
      )
        LoginServices.loginCallback({
          identifier: loggedUser.identifier,
          loggedEntityData: loggedUser,
          deviceID: '',
          refreshToken: loggedUser.refreshToken,
          refreshTokenExpiryTime: loggedUser.refreshTokenExpiryTime,
          role: loggedUser.role,
          token: loggedUser.token,
          username: loggedUser.username,
        })
    }
}

